import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ConsignmentTemplateForm from "./ConsignmentTemplateForm";
import { useParams } from "react-router-dom";
const CreatePage = () => {
    const params = useParams();
    let action = 'Edit';
    if (params.id === "create") {
        action = 'Create';
    }
    return (_jsx("div", { className: "container-fluid", children: _jsxs("article", { className: "article", children: [_jsxs("h2", { className: "article-title", children: [action, " Delivery Favourite"] }), _jsx(ConsignmentTemplateForm, { consignmentTemplateId: params.id })] }) }));
};
export default CreatePage;
